export default defineNuxtRouteMiddleware((to, from) => {
  if (process.env.NODE_ENV === "production" && /store-locator/.test(to.path)) {
    return navigateTo("/?redirect=404", { redirectCode: 404 });
  }

  if (to.matched.length === 0) {
    return navigateTo("/?redirect=404", { redirectCode: 404 });
  }
});
